import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../auth/auth.service';

@Injectable({ providedIn: 'root' })
export class CompaniaFarmaceuticaImportService {
  private readonly url = (environment.urlBackend.endsWith('/') ? environment.urlBackend.slice(0, -1) : environment.urlBackend) + '/signo-compania-farmaceutica';
  constructor(private http: HttpClient, private auth: AuthService) {}
  async request(method: string, path: string, body?: any): Promise<any> {
    const headers = new HttpHeaders({ 'x-token': await this.auth.loadJwToken() });
    const result: any = await this.http.request(method, this.url + path, { body, headers }).toPromise();
    return result && Object.prototype.hasOwnProperty.call(result, 'response') ? result.response : result;
  }
  analyze(file: File, config: any) {
    const body = new FormData(); body.append('file', file); body.append('config', JSON.stringify(config));
    return this.request('POST', '/analyze', body);
  }
  resolveLocality(id: string, zona: string) { return this.request('POST', '/' + id + '/resolve-locality', { zona }); }
  commitOne(id: string, key: string) { return this.request('POST', '/' + id + '/commit-one', { key }); }
  finalize(id: string) { return this.request('POST', '/' + id + '/finalize'); }
}
